import { RollingStartEndpointBuilder } from "../apiTypes";
import { WidgetInstance } from "@src/../graphql-types";
import { IWidgetGroupPreview } from "@src/interface/Widget";

export const createWidgetEndpoint = (builder: RollingStartEndpointBuilder) => ({
  getWidgetInstance: builder.query<
    Omit<WidgetInstance, "children">,
    string | number
  >({
    query: (id_instance: number) => ({
      url: `/widgetinstance/${id_instance}`,
      method: "GET",
    }),
  }),

  getWidgetGroup: builder.query<
    IWidgetGroupPreview,
    { id_widget_group: string }
  >({
    query: ({ id_widget_group }) => ({
      url: `/widgetgroup/${id_widget_group}?with_collections=true&with_instances=true`,
      method: "GET",
      params: {
        with_collections: "true",
        with_instances: "true",
      },
    }),
  }),
});
